"use client";

import { motion } from "framer-motion";

interface HeaderSectionProps {
  title: string
  description?: string
  direction?: 'left' | 'center',
  opositeColor?: boolean
}

const HeaderSection = ({ title, description, direction = 'center', opositeColor }: HeaderSectionProps) => {
  return ( 
    <div className=" mb-10 space-y-2">     
      <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1,x: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div className={`flex flex-col gap-2 ${direction === 'left' ? 'justify-left items-start' : 'justify-center items-center'} group`}> 
          <h1 className={`text-3xl md:text-5xl font-semibold ${opositeColor ? 'text-white' : 'color-default'}`}>
            { title }
          </h1>
           <span className="w-14 bg-secondary h-1" />
        </div>
      </motion.div>

       { description && (
        <div className={`flex  ${direction === 'left' ? 'justify-start' : 'justify-center text-center'}`}>
          <motion.p
            className={`text-base ${opositeColor ? 'text-white' : 'text-muted-foreground'} max-w-xl font-display
               ${direction === 'left' ? 'text-start' : 'text-center'}`}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2}}
            viewport={{ once: true }}
          >
            <span dangerouslySetInnerHTML={{ __html: description }} ></span>
          </motion.p>
        </div>
      )}
    </div>
   );
}
 
export default HeaderSection;